"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPublicMoment = getPublicMoment;
exports.isPublicMoment = isPublicMoment;
exports.buildMoment = buildMoment;

var _react = _interopRequireDefault(require("react"));

var _constants = require("../constants");

var _icon = require("./icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function getPublicMoment(momentData) {
  var type = momentData.type;
  return _constants.API_TO_MOMENT_MAP[type];
}

function isPublicMoment(momentData) {
  return getPublicMoment(momentData) ? true : false;
}

function buildMoment(momentData, index) {
  var MomentComponent = getPublicMoment(momentData);

  if (MomentComponent) {
    var icon = (0, _icon.buildIcon)(momentData.icon);
    return _react.default.createElement(MomentComponent, _extends({}, momentData, {
      icon: icon,
      index: index
    }));
  }

  return null;
}